import React, { useEffect, useState } from "react";
import { TextInput, NumberInput, Select } from "../components/form/inputs";
import DecorativeSquares from "../components/ui/DecorativeSquares"; 
import { useNavigate } from "react-router-dom";
import InputBase from "../components/form/inputs/InputBase";
import PrimaryBtn from "../components/button/PrimaryBtn";
import canada from "../assets/images/svgs/country/canada.svg";
import india from "../assets/images/svgs/country/india.svg";
import usa from "../assets/images/svgs/country/usa.svg";
import CustomerAdded from "../components/Modals/CustomerAdded";
import Plan from "../components/Modals/Plan";
import { getCountry } from "../redux/thunks/registerThunks";
import { useDispatch, useSelector } from "react-redux";
import { GoogleMap, Marker, Autocomplete } from "@react-google-maps/api";
import toast from "react-hot-toast";
import { addNewCustomers } from "../redux/thunks/addCustomerThunk";
import { FaArrowLeft } from "react-icons/fa";

// Helper function for map
const extractAddress = (place) => {
  const address = {
    country: "",
    city: "",
    province: "",
    pincode: "",
    fullAddress: place.formatted_address || "",
    addressLine2: "",
  };

  let sublocality = "";
  let locality = "";
  let route = "";

  place.address_components.forEach((component) => {
    const types = component.types;

    if (types.includes("country")) address.country = component.long_name;
    if (types.includes("administrative_area_level_1"))
      address.province = component.long_name;
    if (types.includes("locality")) {
      address.city = component.long_name;
      locality = component.long_name;
    }
    if (types.includes("sublocality") || types.includes("sublocality_level_1"))
      sublocality = component.long_name;
    if (types.includes("route")) route = component.long_name;
    if (types.includes("postal_code")) address.pincode = component.long_name;
  });

  // 🔥 Short nearby address (priority wise)
  address.addressLine2 =
    sublocality || route || locality || address.province || "";

  return address;
};

const Addnewcustomers = () => {
  const { isCustomerLoading } = useSelector((state) => state.addCustomers);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { countries: countryFromApi } = useSelector(
    (state) => state.setupProfile,
  );
  const [countryCode, setCountryCode] = useState("");
  const [addedCustomer, setAddedCustomer] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [onCustomerSave, setOnCustomerSave] = useState(false);
  const [openPlan, setOpenPlan] = useState(false);
  const [address, setAddress] = useState({
    customersName: "",
    fullAddress: "",
    addressLine2: "",
    province: "",
    pincode: "",
    country: "",
    city: "",
  });

  const [errors, setErrors] = useState({});

  const mapContainerStyle = {
    width: "100%",
    height: "300px",
  };

  const center = {
    lat: 20.5937,
    lng: 78.9629,
  };

  const [mapCenter, setMapCenter] = useState(center);
  const [markerPosition, setMarkerPosition] = useState(null);
  const autocompleteRef = React.useRef(null);
  const [isFetchingAddress, setIsFetchingAddress] = useState(false);

  const onPlaceChanged = () => {
    const place = autocompleteRef.current.getPlace();
    if (!place.geometry) return;

    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    const extracted = extractAddress(place);

    setAddress((prev) => ({
      ...prev,
      ...extracted,
      lat,
      lng,
    }));

    setMapCenter({ lat, lng });
    setMarkerPosition({ lat, lng });
  };
  const handleMapClick = (event) => {
    setIsFetchingAddress(true);
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();

    setMarkerPosition({ lat, lng });
    setMapCenter({ lat, lng });

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        const place = results[0];

        const extracted = extractAddress(place);

        setAddress((prev) => ({
          ...prev,
          ...extracted,
          lat,
          lng,
        }));
      } else {
        toast.error("Unable to fetch address from map");
      }

      setTimeout(() => {
        setIsFetchingAddress(false);
      }, 400);
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const COUNTRY_FLAGS = {
    99: india,
    38: canada,
    226: usa,
  };

  useEffect(() => {
    dispatch(getCountry());
  }, [dispatch]);

  const countries = countryFromApi?.map((cu) => {
    const normalizedName =
      cu.country_name.charAt(0).toUpperCase() +
      cu.country_name.slice(1).toLowerCase();

    return {
      id: cu.id,
      value: cu.id,
      image: COUNTRY_FLAGS[cu.id] || null,
      label: `(+${cu.country_code})`,
      min_phone_length: cu.min_phone_length,
      max_phone_length: cu.max_phone_length,
    };
  });

  useEffect(() => {
    if (countries.length && !countryCode) {
      setCountryCode(countries[0].value);
    }
  }, [countries, countryCode]);

  const selectedCountry = countries.find((c) => c.value === countryCode);

  const validateFields = () => {
    const newErrors = {};

    // ✅ Customer name: required & alphabets only
    if (!address.customersName?.trim()) {
      newErrors.customersName = "Customer name is required";
    } else if (!/^[a-zA-Z\s]+$/.test(address.customersName)) {
      newErrors.customersName = "Customer name should contain only letters";
    }

    // ✅ Contact number: required, numeric, min/max length per country
    if (!contactNo?.trim()) {
      newErrors.contactNo = "Mobile number is required";
    } else if (!/^\d+$/.test(contactNo)) {
      newErrors.contactNo = "Mobile number should contain only digits";
    } else if (selectedCountry) {
      const length = contactNo.length;
      if (
        length < selectedCountry.min_phone_length ||
        length > selectedCountry.max_phone_length
      ) {
        newErrors.contactNo = `Mobile number should be ${selectedCountry.min_phone_length}-${selectedCountry.max_phone_length} digits`;
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleOnCustomersAdd = async () => {
    if (!validateFields()) {
      return;
    }
    try {
      const payload = {
        country_id: selectedCountry.id,
        customer_name: address.customersName,
        contact_no: contactNo,
        address_1: address.fullAddress,
        address_2: address.addressLine2,
        country: address.country,
        city: address.city,
        province: address.province,
        pin_code: address.pincode,
        latitude: address.lat,
        longitude: address.lng,
      };
      // console.log("The payload for adding new customers is :", payload);
      const res = await dispatch(addNewCustomers(payload)).unwrap();

      if (res.success) {
        toast.success(res.message);
        setOnCustomerSave(true);

        setAddedCustomer({
          customer_id: res.data?.customer_id,
        });
        console.log("The customer id is :", addedCustomer.customer_id);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.message || err || "Failed to add customer");
    }
  };

  return (
    <section className="relative max-w-7xl mx-auto px-4 py-6 max-h-screen">
      <DecorativeSquares />

      {/* Header */}
      <div className="sticky top-2 z-10 bg-white/80 backdrop-blur-md rounded-2xl shadow-md px-4 py-3 flex items-center justify-between mb-6">
        <button
          onClick={handleGoBack}
          className="flex items-center p-2 rounded-full hover:bg-gray-100"
        >
          <FaArrowLeft size={20} /> 
        </button>

        <h1 className="mx-auto text-2xl font-semibold text-gray-900">
          Add Customers
        </h1>
      </div>
      <div className="px-0 md:px-4 mt-8">
        <div className="mx-auto space-y-4 w-full max-w-7xl bg-white border border-gray-200 rounded-xl p-3 md:p-6 shadow-sm">
          {/* ================= Address Form ================= */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <TextInput
                label="Customer name"
                placeholder="Enter Customer Name"
                required={true}
                name="customersName"
                value={address.customersName}
                onChange={handleChange}
              />
              {errors.customersName && (
                <p className="text-sm text-red-500 mt-1">
                  {errors.customersName}
                </p>
              )}
            </div>
            <div>
              <label className="text-sm text-gray-600 mb-1 block">
                Contact Number <span className="text-red-500 ml-1">*</span>
              </label>
              <div className="flex gap-3 mb-4">
                {/* Country Code */}
                <div className="w-32">
                  <Select
                    name="countryCode"
                    value={countryCode}
                    onChange={(value) => setCountryCode(value)}
                    options={countries}
                    variant="withImages"
                  />
                </div>

                {/* Mobile Number */}
                <div>
                  <div className="w-2/3">
                    <NumberInput
                      placeholder="Enter mobile number"
                      value={contactNo}
                      onChange={(e) => setContactNo(e.target.value)}
                    />
                  </div>
                  {errors.contactNo && (
                    <p className="text-sm text-red-500 mt-1">
                      {errors.contactNo}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="w-full">
              <p className="text-[#191919] text-sm mb-2 font-medium">
                Delivery Address
              </p>

              <Autocomplete
                onLoad={(ref) => (autocompleteRef.current = ref)}
                onPlaceChanged={onPlaceChanged}
              >
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search location"
                    name="fullAddress"
                    value={address.fullAddress}
                    onChange={handleChange}
                    disabled={isFetchingAddress}
                    className="w-full px-4 py-2 mb-3 border rounded-lg outline-none pr-10"
                  />

                  {isFetchingAddress && (
                    <div className="absolute right-3 top-1/2 -translate-y-1/2">
                      <div className="w-4 h-4 border-2 border-gray-300 border-t-black rounded-full animate-spin"></div>
                    </div>
                  )}
                </div>
              </Autocomplete>
            </div>
            <InputBase
              type="text"
              label="Address line 2"
              placeholder="Apartment, House No, Landmark"
              name="addressLine2"
              value={address.addressLine2}
              onChange={handleChange}
              rows={2}
            />
            <TextInput
              label="City"
              placeholder="Enter City"
              name="city"
              value={address.city}
              onChange={handleChange}
            />
            <TextInput
              label="Country"
              placeholder="Enter Country"
              name="country"
              value={address.country}
              onChange={handleChange}
            />
            <TextInput
              label="Province / State"
              placeholder="Enter Province"
              name="province"
              value={address.province}
              onChange={handleChange}
            />
            <TextInput
              label="Pin Code"
              placeholder="Enter Pin Code"
              name="pincode"
              value={address.pincode}
              onChange={handleChange}
            />
          </div>
          <div className="space-y-2">
            <p className="text-[#191919] font-medium">Choose location</p>
            <GoogleMap
              mapContainerStyle={mapContainerStyle}
              zoom={15}
              center={mapCenter}
              onClick={handleMapClick}
            >
              {markerPosition && <Marker position={markerPosition} />}
            </GoogleMap>
          </div>
          <div>
            <PrimaryBtn
              btnName="Add Customer"
              clickEvent={handleOnCustomersAdd}
              isLoading={isCustomerLoading}
            />
          </div>
        </div>
      </div>
      <CustomerAdded
        open={onCustomerSave}
        onclose={() => setOnCustomerSave(false)}
        onAddQuickOrder={() => {
          setOpenPlan(true);
        }}
        customerId={addedCustomer.customer_id}
      />

      <Plan
        open={openPlan}
        onClose={() => setOpenPlan(false)}
        from="customer"
        state={{ customerId: addedCustomer.customer_id }}
      />
    </section>
  );
};

export default Addnewcustomers;
